import React from 'react'

function Footer() {
    return (
        <section id="footer">
       
<footer className="page-footer font-small special-color-dark pt-4">
  <div className="container">
    <ul className="list-unstyled list-inline text-center">
      <li className="list-inline-item">
        <a className="btn-floating btn-tw mx-1">
        <a href="https://github.com/jigsaw007" target="_blank"><i className="fab fa-github"></i></a>
        </a>
      </li>
      <li className="list-inline-item">
        <a className="btn-floating btn-gplus mx-1">
        <a href="https://www.linkedin.com/in/anuj-joshi-a54069216/" target="_blank"><i className="fab fa-linkedin"></i></a>
        </a>
      </li>
      
    </ul>
  </div>
</footer>
        </section>
    )
}

export default Footer
